import React from 'react'
import {observer} from "mobx-react";
import styles from 'patterns/WorkflowSelector/WorkflowSelector.module.scss'
import {workflowStore} from "stores";
import F from "utils/F";
import Loader from "components/Loader/Loader";
import {WorkflowTemplateCard} from "components/WorkflowCard/WorkflowCard";
import {StringFunctions} from "utils/StringFunctions";
import Lozenge from "components/Lozenge/Lozenge";

const WorkflowSelector = observer(({searchText, setSearchText, product}) => {

    const workflowTemplates = F.arrayFromMapValues(workflowStore.workflowTemplateMap, {userFilter: false})
        .filter(w => w.product === product)
        // Follow-ons (requiresMatter, e.g. a contract variation) are launched from an existing matter,
        // not from the cold catalogue — they appear as actions on the relationship instead (ADR 0003).
        .filter(w => !w.requiresMatter);

    const workflows = workflowTemplates.length > 0 && workflowTemplates
        .filter(w => w.name?.toLowerCase()?.includes(searchText.toLowerCase()) ||
            StringFunctions.getProductArea(w.productArea)?.toLowerCase()?.includes(searchText.toLowerCase()))
        .sort(F.sortByQuery('availability', 'available'))
        .map(w =>
            <WorkflowTemplateCard key={w.code} flow={w} isComingSoon={w.availability === 'COMING_SOON'}/>
        )

    if (!workflowStore.initialised) {
        return <Loader background={'white'}/>;
    }

    const renderQuickSearch = () => {
        const productAreas = new Set()
        workflowTemplates.forEach(w => productAreas.add(w.productArea))
        const renderProductAreas = [...productAreas].map(pa => {
            const productArea = StringFunctions.getProductArea(pa);
            return <Lozenge showMargin key={pa} active={searchText === productArea}
                            onClick={() => setSearchText(productArea)} colour={'Blue'}
                            content={productArea}/>
        })
        return <div className={styles.quickSearch}>
            <h5>Quick Search</h5>
            <Lozenge showMargin active={searchText === ''}
                     onClick={() => setSearchText('')}
                     colour={'Blue'}
                     content={'View All'}/>
            {renderProductAreas}
        </div>
    }

    return <div className={styles.flowSelector}>
        <div className={styles.workflows}>
            {renderQuickSearch()}
            {workflows}
        </div>
    </div>
})

export default WorkflowSelector